import React from "react";
import './AboutPage.css';


function AboutPage(props) {
  return (
    <div id="aboutBlk">
      <div>It is possible to see the site Privacy Policy by clicking the button below.</div>
      <button id = 'ppBtn'
              onClick = {
                () => window.open("privacy-policy.html")
              } >
        Privacy Policy
      </button>
    </div>
  )
} /* End of AboutPage */

export default AboutPage;
